import React from 'react';
import styles from './content-list-item.css';
import { Stat } from './stat';

interface Props {
  visitors: number;
  conversions: number;
  conversionRate: number;
}

export const StatsContainer = ({ visitors, conversions, conversionRate }: Props) => (
  <ul className={styles.statsWrapper} data-testid="stats-container">
    <Stat statTestId="visitor" value={visitors} label="visitors" />
    <Stat statTestId="conversion" value={conversions} label="conversions" />
    <Stat statTestId="conversion-rate" value={`${conversionRate}%`} label="conversion rate" />
  </ul>
);

export default StatsContainer;
